export const navFinancialMenu = [
  [
    {
      key: 'financial:1',
      url: 'https://carolinas.aaa.com/financial/',
      label: 'AAA Financial',
    },
    {
      key: 'financial:4',
      url: 'https://carolinas.aaa.com/membership/career-assistance/',
      label: 'Career Assistance',
    },
    {
      key: 'financial:5',
      url: 'https://www.aaa.com/experianidtheft/',
      label: 'Identity Theft Monitoring',
    },
    {
      key: 'financial:6',
      url:
        'https://carolinas.discounts.aaa.com/deal/details/303024?club=111&ov=t',
      label: 'Tax Preparation',
    },
    {
      key: 'financial:7',
      url: 'https://carolinas.aaa.com/financial/deposits/',
      label: 'AAA Banking',
    },
    {
      key: 'financial:12',
      url:
        'https://card.creditcard.acg.aaa.com/credit/welcome.do?exp=&lang=en&redirect=AAAWeb&referral=',
      label: 'AAA Credit Card',
    },
  ],
  [
    {
      key: 'financial:7',
      url:
        'https://autoloan.autoclubtrust.aaa.com/Financial/Auto/cdx/ProductInfoNCSC.aspx?intcmp=bank_aln_w_tl_ncsc-menu',
      label: 'Auto Loans',
    },
    {
      key: 'financial:8',
      url: 'https://member.acg.aaa.com/111/aaabanking/home-mortgage-loan.html',
      label: 'Mortgage Loans',
    },
    {
      key: 'financial:9',
      url: 'https://carolinas.aaa.com/financial/personal-finance/',
      label: 'Personal Finance & Savings',
    },
    {
      key: 'financial:10',
      url: 'https://carolinas.aaa.com/financial/annuities/',
      label: 'Annuities',
    },
    {
      key: 'financial:11',
      url: 'https://carolinas.aaa.com/financial/travel-money/',
      label: 'Travel Money',
    },
  ],
];

export const navFinancialPromo = [
  {
    title: 'AAA Financial Services',
    content: `AAA offers members trusted financial solutions to help you manage and make the most of your finances. With identity theft protection, auto & home loans, tax preparation and more, see how our preferred financial partners can help you today.`,
    img: '',
    buttonText: 'Learn More',
    buttonUrl: 'https://carolinas.aaa.com/financial/',
  },
];
